import { render } from "./WarningsComponent.vue?vue&type=template&id=0d6f82bb"
import script from "./WarningsComponent.vue?vue&type=script&lang=js"
export * from "./WarningsComponent.vue?vue&type=script&lang=js"

import "./WarningsComponent.vue?vue&type=style&index=0&id=0d6f82bb&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__